import { render } from "./RoleDetails.vue?vue&type=template&id=404e666f&scoped=true"
import script from "./RoleDetails.vue?vue&type=script&lang=js"
export * from "./RoleDetails.vue?vue&type=script&lang=js"

import "./RoleDetails.vue?vue&type=style&index=0&id=404e666f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404e666f"]])

export default __exports__